export default __webpack_public_path__ + "static/media/R_CSOGESTER.cce86f23.pdf";